import tDImg from "../../../../images/contents/map/tropicalstorm/TD.png";
import tSImg from "../../../../images/contents/map/tropicalstorm/TS.png";
import tSSouthImg from "../../../../images/contents/map/tropicalstorm/TS_south.png";
import tYImg from "../../../../images/contents/map/tropicalstorm/TY.png";
import tYSouthImg from "../../../../images/contents/map/tropicalstorm/TY_south.png";
import xTImg from "../../../../images/contents/map/tropicalstorm/XT.png";

export const configCycloneDhWniIndex = {
  "Controller": {
    "Name": "IndexedJSON"
  },
  "Source": {
    "index": {
      "Type": "JSON",
      "url": "%wrap_url%/WX_WNI_TropicalStorm/index.json",
      "data_load_term_days": 1,
      "update_interval": 60,
      "cache_busting": true
    },
    "element": {
      "Type": "JSON",
      "url": "%wrap_url%/WX_WNI_TropicalStorm/TropicalStorm/%id%.json",
      "cache_busting": true,
      "download_max": 32
    },
    "data": {
      "Type": "Derived",
      "retain": true
    }
  }
};

export const configCycloneWniLayer = {
  "Name": "TropicalStorm",
  "Renderer": "TropicalStormExt",
  "Attributes": {
    "track_history_line_color": "#802020",
    "track_history_line_width": 2,
    "_forecst_track_line_color": "#2020ee",
    "forecst_track_line_color": "#0000ff",
    "forecst_track_line_width": 2,
    "wind_line_color_gale": "rgba(255,201,102,1.0)",
    "wind_line_color_storm": "rgba(255,50,50,1.0)",
    "wind_line_width": 1,
    "wind_fill_color_gale": "rgba(255,201,102,0.3)",
    "wind_fill_color_storm": "rgba(255,50,50,0.3)",
    "wind_highlight_line_width": 5,
    "label_text_color": "#202020",
    "label_edge_color": "#ffffff",
    "label_offset_x": 10,
    "label_offset_y": 10,
    "label_font_size": 14,
    "date_format": "%day%/%0hour%Z",
    "date_format_bylocale": "D/HH z[Z]",
    "icon": {
      "HUR": tYImg,
      "CYC": tYImg,
      "TY": tYImg,
      "STS": tSImg,
      "TS": tSImg,
      "TD": tDImg,
      "XT": xTImg
    },
    "icon_south": {
      "HUR": tYSouthImg,
      "CYC": tYSouthImg,
      "TY": tYSouthImg,
      "STS": tSSouthImg,
      "TS": tSSouthImg
    },
    "icon_width": 16,
    "icon_height": 23,
    "icon_offset_x": -8,
    "icon_offset_y": -12,
    "show_forecast_track": true,
    "show_track_history": true,
    "show_forecast_wind_radii": true,
    "show_analysis_wind_radii": true,
    "show_datetime": true,
    "show_number": true
  }
};